import { render } from "./AdminHome.vue?vue&type=template&id=78971dbc&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=78971dbc&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78971dbc"]])

export default __exports__